<template>
    <span class="text-primary">
        <i
            class="fa fa-check-circle-o fa-lg icon-button"
            title="Aprovar"
            @click.stop="confirmarAprovacao()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        solicitacaoReabertura: {
            type: Object,
            default: () => {}
        },

        solicitacoesReaberturasServicos: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarAprovacao() {
            this.$swal({
                title: 'Solicitação de Reabertura Aprovada',
                html: `Confirma que a solicitação de reabertura da entrega ${this.solicitacaoReabertura.entrega.descritivo} da contratação ${this.solicitacaoReabertura.entrega.contratacao.codContratacao} foi aprovada?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.aprovar()
                }
            })
        },

        aprovar() {
            this.$store.dispatch('addRequest')
            this.solicitacoesReaberturasServicos
                .aprovar(this.solicitacaoReabertura.solicitacaoReaberturaId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Solicitação de reabertura aprovada com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizar-listagem')
                        } else {
                            this.$toast.error(
                                'Falha ao atualizar a solicitação de reabertura',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}
</script>
